import React from 'react';

const HeaderSearchBarContext = React.createContext<null | {}>(null);

export default HeaderSearchBarContext;
